var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-responsive', {
    staticClass: "full-width",
    attrs: {
      "width": "100%"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: _vm.schedule.kind,
      callback: function callback($$v) {
        _vm.$set(_vm.schedule, "kind", $$v);
      },
      expression: "schedule.kind"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "온라인",
      "value": "online"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "오프라인",
      "value": "offline"
    }
  })], 1), _c('div', {
    staticClass: "text-explain mb-2"
  }, [_c('p', [_vm._v("매칭상담은 온라인 또는 오프라인으로 선택하여 진행 가능합니다.")]), _c('p', [_vm._v("희망하시는 매칭상담 방식을 선택해주세요.")]), _c('small', [_vm._v("※ 온라인 진행 시 Zoom 프로그램을 활용한 매칭상담 진행, 오프라인 진행 시 기업과 1:1 대면 매칭상담 진행 예정")])])], 1), _c('v-col', {
    staticClass: "ml-auto",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "depressed": "",
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1)], 1), _vm.fair ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.schedules,
      "width": "100%",
      "hide-default-footer": "",
      "hide-default-header": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(_ref) {
        var props = _ref.props;
        return [_c('thead', [_c('tr', _vm._l(props.headers, function (head, index) {
          return _c('th', {
            key: index
          }, [_vm._v(_vm._s(head.text))]);
        }), 0)])];
      }
    }, {
      key: "body",
      fn: function fn(_ref2) {
        var items = _ref2.items;
        return [_c('tbody', _vm._l(items, function (item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(item.time))]), _vm._l(_vm.dates, function (date) {
            return _c('td', {
              key: date,
              class: {
                'light-blue lighten-5': !_vm.already({
                  date: date,
                  time: item.time
                }),
                'pink lighten-2': _vm.already({
                  date: date,
                  time: item.time
                })
              }
            }, [_c('v-layout', {
              attrs: {
                "justify-center": ""
              }
            }, [_vm.already({
              date: date,
              time: item.time
            }) ? _c('span', {
              staticClass: "white--text"
            }, [_vm._v(_vm._s(_vm.already({
              date: date,
              time: item.time
            }).seller.companyName[_vm.$i18n.locale]))]) : _vm.schedule.schedules.find(function (schedule) {
              return schedule.date == date && schedule.time == item.time;
            }) ? _c('v-simple-checkbox', {
              staticClass: "mt-0",
              attrs: {
                "hide-details": "",
                "value": true,
                "color": "light-blue darken-1"
              },
              on: {
                "click": function click($event) {
                  $event.preventDefault();
                  _vm.schedule.schedules = _vm.schedule.schedules.filter(function (schedule) {
                    return schedule.date != date || schedule.time != item.time;
                  });
                }
              }
            }) : _c('v-simple-checkbox', {
              staticClass: "mt-0",
              attrs: {
                "hide-details": "",
                "value": false,
                "color": "primary"
              },
              on: {
                "click": function click($event) {
                  $event.preventDefault();
                  return _vm.schedule.schedules.push({
                    date: date,
                    time: item.time
                  });
                }
              }
            })], 1)], 1);
          })], 2);
        }), 0)];
      }
    }], null, false, 3973636350)
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }